import { useCallback, useEffect, useState } from 'react';

/* -------------------------------------------------------------------------------------------------
 * Hook: useProjectDefaultView
 * -----------------------------------------------------------------------------------------------*/

enum FloorPlaViewTypeEnum {
    DEFAULT = 'DEFAULT',
    GUI = 'GUI',
}

const useFloorPlanDefaultView = () => {
    const getDefaultView = useCallback(() => {
        return (localStorage.getItem('floor_plan_view') as FloorPlaViewTypeEnum) || FloorPlaViewTypeEnum.DEFAULT;
    }, []);

    const setDefaultView = useCallback((value: string) => {
        return localStorage.setItem('floor_plan_view', value);
    }, []);

    const [view, setView] = useState<FloorPlaViewTypeEnum>(getDefaultView());

    useEffect(() => {
        setDefaultView(view);
    }, [view, setDefaultView]);

    const toggleView = useCallback(() => {
        setView((prev) => {
            if (prev === FloorPlaViewTypeEnum.DEFAULT) return FloorPlaViewTypeEnum.GUI;

            return FloorPlaViewTypeEnum.DEFAULT;
        });
    }, []);

    return {
        isDefaultView: view === FloorPlaViewTypeEnum.DEFAULT,
        isGuiView: view === FloorPlaViewTypeEnum.GUI,
        toggleView,
    };
};

export default useFloorPlanDefaultView;
